import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { i18n } from '@lingui/core';
import { MentionList } from './MentionList';

const sequentialNumberPlaceholders = [
  { label: 'Aktuelles Jahr', id: 'CURRENT_YEAR' },
  { label: 'Aktueller Monat', id: 'CURRENT_MONTH' },
  { label: 'Aktueller Monat 2-stellig', id: 'CURRENT_MONTH_TWO_DIGITS' },
  { label: 'Aktueller Tag', id: 'CURRENT_DAY' },
  { label: 'Fortlaufende Nummer', id: 'seq_no' },
];

const getFilteredMentions = (query) =>
  sequentialNumberPlaceholders.filter((item) => i18n._(item.label).toLowerCase().includes(query.toLowerCase()));

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  char: '#',
  allowedPrefixes: null,
  items: ({ query }) => getFilteredMentions(query),
  render: () => {
    let reactRenderer;
    let popup;

    return {
      onStart: (props) => {
        reactRenderer = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: reactRenderer.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        });
      },

      onUpdate(props) {
        reactRenderer.updateProps(props);

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        return reactRenderer.ref?.onKeyDown(props);
      },

      onExit() {
        popup[0].destroy();
        reactRenderer.destroy();
      },
    };
  },
};
